var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel24 = function SvgCancel24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.537 18.249a.857.857 0 1 0 1.212-1.212L13.212 12.5l4.537-4.537a.857.857 0 1 0-1.212-1.212L12 11.288 7.463 6.75a.857.857 0 0 0-1.212 1.212l4.537 4.537-4.537 4.537a.857.857 0 1 0 1.212 1.212L12 13.712l4.537 4.537Z",
    fill: "currentColor"
  })));
};
export default SvgCancel24;